import { useQuery } from '@tanstack/vue-query';
import { Ref, ref, watch } from 'vue';

import formalization from '~/services/formalization-api/formalization';
import { DownloadDDCResponse } from '~/services/formalization-api/formalization.types';
import { queryKeys } from '~/store/queryClient';

const useDownloadDDC = (financingId: Ref<number | undefined>) => {
  const queryKey = ref(queryKeys.FORMALIZATION.DOWNLOAD_DDC(financingId.value?.toString() ?? ''));

  watch(financingId, (newFinancingId) => {
    queryKey.value = queryKeys.FORMALIZATION.DOWNLOAD_DDC(newFinancingId?.toString() ?? '');
  });

  const queryFn = (): Promise<DownloadDDCResponse> => formalization.downloadDDC(financingId.value?.toString() ?? '');

  return useQuery({
    enabled: false,
    queryFn,
    queryKey,
    retry: 3,
  });
};

export default useDownloadDDC;
